import React from "react"
import styled from "styled-components"
import Breakpoints from "../../components/shared/breakpoints"
import withAnimation from "../util/withAnimation"

export interface IStyleVariant {
  sm?: any
  md?: any
  lg?: any
}

export interface IVariantContainerProps {
  variants?: IStyleVariant | any[]
  className?: String
}

const VariantContainer = styled.div<IVariantContainerProps>`
  ${(props) =>
    Array.isArray(props.variants) ? props.variants[0] : props.variants?.sm}

  @media(min-width: ${Breakpoints.md}) {
    ${(props) =>
      Array.isArray(props.variants) ? props.variants[1] : props.variants?.md}
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${(props) =>
      Array.isArray(props.variants) ? props.variants[2] : props.variants?.lg}
  }
`

export default VariantContainer
